/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from '@solana/kit';
import {
  getDelegationDecoder,
  getDelegationEncoder,
  type Delegation,
  type DelegationArgs,
} from '.';

export type Stake = { delegation: Delegation; creditsObserved: bigint };

export type StakeArgs = {
  delegation: DelegationArgs;
  creditsObserved: number | bigint;
};

export function getStakeEncoder(): Encoder<StakeArgs> {
  return getStructEncoder([
    ['delegation', getDelegationEncoder()],
    ['creditsObserved', getU64Encoder()],
  ]);
}

export function getStakeDecoder(): Decoder<Stake> {
  return getStructDecoder([
    ['delegation', getDelegationDecoder()],
    ['creditsObserved', getU64Decoder()],
  ]);
}

export function getStakeCodec(): Codec<StakeArgs, Stake> {
  return combineCodec(getStakeEncoder(), getStakeDecoder());
}
